import { render } from "./IletsCoursesPage.vue?vue&type=template&id=2f8d7c55&scoped=true"
import script from "./IletsCoursesPage.vue?vue&type=script&lang=js"
export * from "./IletsCoursesPage.vue?vue&type=script&lang=js"

import "./IletsCoursesPage.vue?vue&type=style&index=0&id=2f8d7c55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8d7c55"]])

export default __exports__